export default {
  bannerText: ``,
}
